import {

} from 'react-router';

function cardUtil() {
  let allFeaturesList = {};
  // let accountId = null;

  return {
    init(featureList) {
      allFeaturesList = featureList;
    },
    // setAccountId(id) {
    //   accountId = id;
    // },
    isFeatureFlagEnabled(feature, accountId) {
      let params = new URLSearchParams(document.location.search.substring(1));
      let name = params.get(feature); // will be true or false in the Url
      if (allFeaturesList[feature] === true && name === "true") {
        return true;
      }
      if (typeof allFeaturesList[feature] === "boolean") {
        return allFeaturesList[feature];
      }
      if (accountId && Array.isArray(allFeaturesList[feature])) {
        return allFeaturesList[feature].indexOf(accountId) > -1
      }
      return false;
    },
  };
}

export default cardUtil();



// WEBPACK FOOTER //
// ./src/utils/cardUtil.js